import { CurrencyPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output, viewChild } from '@angular/core';
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { InputNumber } from 'primeng/inputnumber';
import { InputNumberInputEvent } from 'primeng/types/inputnumber';
import { AbstractControlToFormControlPipe } from '../../../pipes/abstract-control-to-form-control.pipe';
import { WithReadonly } from '../base/with-readonly';

export enum InputNumberTypeEnum {
  Percent = 'percent',
  Currency = 'currency',
  PlainNumber = 'plain-number',
}

@Component({
  selector: 'shared-input-number',
  templateUrl: './input-number.component.html',
  styleUrls: ['./input-number.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, InputNumber, AbstractControlToFormControlPipe, CurrencyPipe],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class InputNumberComponent extends WithReadonly {
  readonly type = input<'percent' | 'currency' | 'plain-number'>('plain-number');
  readonly name = input<string>();
  readonly placeholder = input<string>();
  readonly suffix = input<string>();
  readonly minFractionDigits = input<number | null>(null);
  readonly maxFractionDigits = input<number | null>(null);
  readonly min = input<number | null>(null);
  readonly max = input<number | null>(null);
  readonly formatNumber = input(true);

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  readonly onChange = output<InputNumberInputEvent>();

  readonly inputNumber = viewChild(InputNumber);
}
